export default __webpack_public_path__ + "static/media/box-text-links.69c2cae0.png";